import {
  FilterKey,
  filterKeyFromResponse,
} from '../interfaces/Filter/FilterKey';
import api, { apiPrefix } from './Api';

export const getFiltersByCategory = async (
  categorySlug: string,
): Promise<FilterKey[]> => {
  const response = await api.get(`${apiPrefix}/getFiltersForProduct`, {
    params: { categorySlug },
  });

  return (response.data?.data ?? []).map(filterKeyFromResponse);
};
